import Swup from 'swup';
// import SwupScriptsPlugin from '@swup/scripts-plugin';

// import SwupScriptsPlugin from '@swup/scripts-plugin/dist/SwupScriptsPlugin.min';
// import Splide from '@splidejs/splide';
import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect'

Alpine.plugin(intersect)

const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

const options = {
  plugins: [
    new SwupScriptsPlugin({
      optin: true
    })
  ]
};

const swup = new Swup(options); 

// // Events
swup.hooks.on('content:replace', init);

// // Start Apline after swup so it works correctly
window.Alpine = Alpine
Alpine.start();

document.addEventListener("DOMContentLoaded", () => {
  l('ready');
  // checkCookie();
  init();
});

// Functions 
function l(m) { 
  console.log(m); 
}

function init() {
  l('👍')
  l('jump to top')
  document.querySelector('.scrollin').scrollTo({
    top: 0,
    behavior: 'auto'
  });
  workLoop();  
  cursorSmall()
  // startSliders();
  // cookieNotice();
}

function cursorSmall() {
  l('cursorSmall');
  document.querySelectorAll('a').forEach((el) => {

    el.addEventListener('mouseenter', () => {
      // l('link entered');
      document.querySelector('#follower').classList.add('small')
    });
    el.addEventListener('mouseleave', () => {
      // l('link left');
      document.querySelector('#follower').classList.remove('small')
    });
    el.addEventListener('click', () => {
      // l('link clicked');
      document.querySelector('#follower').classList.remove('small')
    });
  })
}


function workLoop() {
  if(window.location.pathname == '/') { 
    console.log('workloop fired');
    const scrollContainer = document.querySelector(".work")
    const container = document.querySelector('.work_loop')
    const clone = container.cloneNode(true)
    const parent = container.parentElement
    parent.appendChild(clone)
    parent.scrollTo(0, 2)


    scrollContainer.addEventListener("scroll", (e)=> {

      if(scrollContainer.offsetHeight + scrollContainer.scrollTop >= scrollContainer.scrollHeight){
        const container = document.querySelector(".work_loop")
        const clone = container.cloneNode(true)
        const parent = container.parentElement
        parent.appendChild(clone)
        parent.children[0].remove()
      } 

      if(scrollContainer.scrollTop == 0){
        console.log("TOP")
        const container = document.querySelector(".work_loop")
        const clone = container.cloneNode(true)
        const parent = container.parentElement
        parent.insertBefore(clone, parent.firstChild)
        parent.scrollTo(0, container.scrollHeight)
        parent.lastElementChild.remove()
      } 
      
    });
  }
}





// // function startSliders() {
// //   if(document.querySelectorAll('.splide').length) { 
// //     let perPage = isMobile ? 1.5 : 3.5;
// //     let splide = new Splide( '.splide', {
// //       type: 'loop',
// //       focus  : 'left',
// //       perPage: perPage,
// //       arrows: true,
// //       pagination: false
// //     });

// //     splide.mount();
// //   }

// // }

// function cookieNotice() {
//   l('cookienotice');
//   document.querySelector('.cookie_btn').addEventListener('click', setCookie);
// }

// function setCookie() {
//   l('set cookie');
//   document.cookie = 'cookie-note=1;max-age=864000';
//   document.querySelector('.cookie').classList.add('hidden');
// }